<template>
  <div class="comContent">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="商品基库" name="1">
        <depotList ref="depot-list" v-if="activeName == '1'" />
      </el-tab-pane>
      <el-tab-pane label="商家申请" name="2">
        <businessApply ref="business-apply" v-if="activeName == '2'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import depotList from "./depotList.vue";
import businessApply from "./businessApply.vue";

export default {
  components: { depotList, businessApply },
  props: {},
  data() {
    return {
      activeName: "1",
    };
  },
  filters: {},
  created() {},
  mounted() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
  },
  methods: {
    handleClick() {
       this.$router.push(
        "./goodsManage-baseDepot-index?activeName=" +  this.activeName
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
</style>
